var $632db85e92394c25$exports = {};
$632db85e92394c25$exports = {
    "colorSwatchPicker": `Uzorci boja`,
    "dropzoneLabel": `Zona spu\u{161}tanja`,
    "selectPlaceholder": `Odaberite stavku`,
    "tableResizer": `Promjena veli\u{10D}ine`
};


export {$632db85e92394c25$exports as default};
//# sourceMappingURL=hr-HR.mjs.map
